import { useStyles } from '@archipro-design/aria';
import { useBoolean } from 'ahooks';
import * as S from './TradeOnlyBanner.style';
import LoginSignUpModal from '~/modules/user/component/login-signup-modal/LoginSignUpModal';
import { isUserLoggedIn } from '~/modules/user';
import type { User } from '~/server/types';

interface Props {
    user: User;
    selectedVariant: {
        TradeOnlyEnabled: boolean;
        TradePrice?: {
            Amount: number;
        } | null;
    } | null;
}
const TradeOnlyBanner = ({ user, selectedVariant }: Props) => {
    const [showSignIn, setShowSignIn] = useBoolean(false);
    const { css } = useStyles();

    if (
        isUserLoggedIn(user) ||
        !selectedVariant?.TradeOnlyEnabled ||
        !selectedVariant?.TradePrice?.Amount
    ) {
        return null;
    }

    return (
        <div className={css(S.BannerContainer)}>
            <div>
                <u onClick={setShowSignIn.setTrue}>Sign in as a professional</u>{' '}
                to purchase trade only products
            </div>
            <LoginSignUpModal
                login={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                    onConfirm: setShowSignIn.setFalse,
                    onAuthSuccess: setShowSignIn.setFalse,
                    flow: null,
                    authSource: 'tradeOnlyBanner',
                }}
                forgotPassword={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                }}
            />
        </div>
    );
};

export default TradeOnlyBanner;
